import Vue from 'vue'

export default {
  setCurrentFolderSelection(state, data) {
    state.currentFolderSelection = data
  },
  setCurrentFolderPath(state, path) {
    state.documentsTable.currentFolderPath = path
  },
  setCurrentFolder(state, folder) {
    state.documentsTable.currentFolder = folder
  },
  setDialogCurrentFolder(state, folder) {
    state.dialogDocumentsTable.currentFolder = folder
  },
  setDialogCurrentFolderPath(state, path) {
    state.dialogDocumentsTable.currentFolderPath = path
  },
  setCurrentFile(state, file) {
    state.currentFile = file
  },
  setMoveFileDialog(state, dialogState) {
    state.moveFileDialog = dialogState
  },
  setCopyFileDialog(state, dialogState) {
    state.copyFileDialog = dialogState
  },
  setDeleteFileDialog(state, dialogState) {
    state.deleteFileDialog = dialogState
  },
  setDuplicateFileDialog(state, dialogState) {
    state.duplicateFileDialog = dialogState
  },
  setRenameFileDialog(state, dialogState) {
    state.renameFileDialog = dialogState
  },
  setNavigationFolderHistory(state, folder) {
    const index = state.documentsTable.navigationFolderHistory.findIndex(f => f.id === folder.id)
    if (index !== -1) {
      const updatedNavHistory = Object.assign([], state.documentsTable.navigationFolderHistory)
      updatedNavHistory[index] = folder
      Vue.set(state.documentsTable, "navigationFolderHistory", updatedNavHistory)
    } else {
      const updatedNavHistory = Object.assign([], state.documentsTable.navigationFolderHistory)
      updatedNavHistory.push(folder)
      Vue.set(state.documentsTable, "navigationFolderHistory", updatedNavHistory)
    }
  },
  clearNavigationFolderHistory(state) {
    Vue.set(state.documentsTable, "navigationFolderHistory", [])
  },
  setDialogNavigationFolderHistory(state, folder) {
    if (!Array.isArray(folder)) {
      const index = state.dialogDocumentsTable.navigationFolderHistory.findIndex(f => f.id === folder.id)
      if (index !== -1) {
        const updatedNavHistory = Object.assign([], state.dialogDocumentsTable.navigationFolderHistory)
        updatedNavHistory[index] = folder
        Vue.set(state.dialogDocumentsTable, "navigationFolderHistory", updatedNavHistory)
      } else {
        const updatedNavHistory = Object.assign([], state.dialogDocumentsTable.navigationFolderHistory)
        updatedNavHistory.push(folder)
        Vue.set(state.dialogDocumentsTable, "navigationFolderHistory", updatedNavHistory)
      }
    } else {
      state.dialogDocumentsTable.navigationFolderHistory = folder
    }
  },
  setBreadcrumbs(state, breadcrumbs) {
    state.documentsTable.breadcrumbs = breadcrumbs
  },
  setDialogBreadcrumbs(state, breadcrumbs) {
    state.dialogDocumentsTable.breadcrumbs = breadcrumbs
  },
  clearFolderSelection(state) {
    state.currentFile = null
    state.currentFolderSelection = null
  },
  setFoldersLoading(state, bool) {
    state.documentsTable.loading = bool
  },
  setDialogFoldersLoading(state, bool) {
    state.dialogDocumentsTable.loading = bool
  },
  setDialogFolders(state, { caseFolders }) {
    if (Array.isArray(caseFolders)) {
      Vue.set(state.dialogDocumentsTable, "folders", caseFolders)
    }
  },
  toggleFileSelection(state, selections) {
    Vue.set(state, "selectedAttachments", selections)
  },
  clearFileSelection(state) {
    Vue.set(state, "selectedAttachments", [])
  },
  setAllFileCheckboxSelected(state, status) {
    state.allFileCheckboxSelected = status
  }
}
